import 'core-js';
import 'focus-visible';
import { Router } from 'react-router';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { enableMapSet, enablePatches } from 'immer';
import { createTheme, ThemeProvider } from '@chaser/components';
import '@chaser/components/dist/index.css';
import 'sanitize.css/sanitize.css';
import './index.scss';
import App from './App';
import { history, persistor, store } from './store';
import ToastContainer from './components/ToastContainer';
import LoadBoundary from './components/LoadBoundary';
import { initFirebase } from './firebase';
import { initTracking } from './util/analytics';
import { initLogging } from './util/logging';
import ModalRenderer from './components/ModalRenderer';
import BannerRenderer from './components/BannerControl/BannerRenderer';

if (typeof window !== 'undefined') {
  window.__CHASER_SHELL_LOADED__ = true;
}

const rootElement = document.querySelector('#root');
const root = ReactDOM.createRoot(rootElement);

enableMapSet();
enablePatches();
initFirebase();
initTracking();
initLogging();

const theme = createTheme();

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <Router history={history}>
          <LoadBoundary center root>
            <BannerRenderer>
              <ModalRenderer>
                <App />
                <ToastContainer />
              </ModalRenderer>
            </BannerRenderer>
          </LoadBoundary>
        </Router>
      </ThemeProvider>
    </PersistGate>
  </Provider>
);
